var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v25h25V0H0zm20 8.75v.469c0 5.156-3.906 10.937-10.938 10.937-2.187 0-4.218-.625-5.937-1.718h.938c1.875 0 3.437-.625 4.843-1.72-1.719 0-3.125-1.093-3.594-2.655h.782c.312 0 .625 0 .937-.157-1.718-.312-3.125-1.875-3.125-3.75.469.313 1.094.469 1.719.469C4.531 10 3.906 8.75 3.906 7.5c0-.781.156-1.406.469-1.875 1.875 2.344 4.844 3.75 7.969 3.906 0-.312-.156-.625-.156-.937a3.868 3.868 0 013.906-3.906c1.093 0 2.031.468 2.812 1.25a6.902 6.902 0 002.5-.938c-.312.938-.937 1.719-1.718 2.188.78-.157 1.562-.313 2.187-.625C21.406 7.5 20.781 8.124 20 8.75z",
    fill: "#fff"
  })));
}

export default SvgTwitter;